export default __webpack_public_path__ + "static/media/pt.c3605e42.svg";